
<div id="titulo">
  <h2>Buscador de talleres</h2>
  <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</div>
<div *ngIf="mostrarMapa else cargando" style="margin-right: 13px; margin-left: 13px;">
  <iframe id="map" [src]="webUrl" width="100%" ></iframe>
</div>
<ng-template #cargando>
  <div style="width: 100%;height:80%;justify-content: center; display: grid;">
    <h3 style="text-align: center;">Cargando...</h3>
    <mat-spinner style="width: 20em;height:20em;"></mat-spinner>
  </div>
</ng-template>
<div *ngIf="cargaSinResultados">
  <p>No se han encontrado talleres cercanos con esos critérios.</p>
  <div *ngIf="this.data.km < 100">
    <p>Prueba con un rango de KM mayor.</p>
  </div>
  <div *ngIf="this.data.km == 100">
    <p>Prueba con otra dirección / Código postal</p>
  </div>
</div>
<h3 style="text-align: center; font-size: 17px; margin:5px;">Dirección cliente: {{this.data.direccionBusqueda}}</h3>
<div id="tablaContainer">
  <table mat-table [dataSource]="dataSource" class="tabla-art" style="min-width: auto; font-family: 'Exo 2 Regular', sans-serif; font-size: 17px; letter-spacing: 0;">
    <!-- Define the columns -->
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
      <!-- Handle the 'ruta' column separately -->
      <ng-container *ngIf="column === 'ruta'; else columnNormal">
        <th mat-header-cell *matHeaderCellDef style="background: white;"></th>
        <td mat-cell *matCellDef="let element" (click)="calcularRuta(element)">
          <button mat-icon-button color="primary" style=" width: 100%;display: block;">
            <img src="assets/icons/location.svg" style="color: #093a33 !important;">
          </button>
        </td>
      </ng-container>
      <!-- Render other columns normally -->
      <ng-template #columnNormal>
        <th style="text-transform: capitalize" mat-header-cell *matHeaderCellDef>{{ column }}</th>
        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
      </ng-template>
    </ng-container>
    <!-- Render the rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (dblclick)="volcarTallerSeleccionado(row)"></tr>
  </table>
</div>

